// extracted by mini-css-extract-plugin
export default {"StatsBlock":"StatsBlock_StatsBlock__ahgjx","container":"StatsBlock_container__Awvcn","pair":"StatsBlock_pair__G2Vmo","item":"StatsBlock_item__+Fxtd"};